<template>
  <GenericStep v-bind="$attrs">
    <DemographicsCard
      :id="peSharedQESliderPartyId"
      :item="peParty"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import DemographicsCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/DemographicsCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'

export default {
  name: 'PartyDetailsStep',

  components: {
    DemographicsCard,
    GenericStep,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty, [
          'religion',
          'race',
          'ethnicity',
          'yearly_household_income_range',
          'household_size',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
      'peSharedQESliderPartyId',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
